export const environment = {
  production: false,
 apiUrl: 'https://2wb-dev-api-enterprise.iconflux.info/api/v1/', // 'http://localhost:3000/api/v1/', //http://localhost:
 faviconUrl: 'https://dev-enterprisegpt.s3.ap-south-1.amazonaws.com/assets/logo/favicon.ico',
 enableRetentionDashboard: false,
 meetingIntelligenceUrl: 'https://cogito-flow-36.lovable.app/dashboard/meeting-intelligence',
};
